export function getMediaType(media) {
  const { mimeType } = media || {};
  
  if (mimeType) {
    return mimeType.toString().match(/image/i) ? 'image' : 'video';
  }
  return mimeType.toString().match(/\.(jpg|png|jpeg|gif)$/i) ? 'image' : 'video';

}
